/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TeamItemDto } from './teamItemDto';
import { TenantItemDto } from './tenantItemDto';
import { UserItemDto } from './userItemDto';
import { ManagerDetails } from './managerDetails';


export interface BuildingAllocationDataDto { 
    ownerTenant: TenantItemDto;
    team?: TeamItemDto;
    propertyManager?: UserItemDto;
    embeddedPropertyManager?: ManagerDetails;
    owner?: BuildingAllocationDataDto.OwnerEnum;
    propertyCaretaker?: string;
    assistant?: string;
}
export namespace BuildingAllocationDataDto {
    export type OwnerEnum = 'YES' | 'NO';
    export const OwnerEnum = {
        Yes: 'YES' as OwnerEnum,
        No: 'NO' as OwnerEnum
    };
}


